




























































































































































































































































import {
  defineComponent,
  onMounted,
  ref,
  computed,
  useRouter,
} from "@nuxtjs/composition-api";
import { getUrlPathByCategoryId } from "~/modules/catalog/category/helpers";
import LazyComponent from "v-lazy-component/vue2";

import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import { useSearchProducts } from "~/composables";

import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination]);

import { checkHttpLink, changeImage } from "~/helpers";

export default defineComponent({
  name: "ProductTabsCate",
  components: {
    CategoryProductCard,
    LazyComponent,
    Swiper,
    SwiperSlide,
    SkeletonLoader,
    ProductLoadItem,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const router = useRouter();
    const products = ref([]);
    const { fetchProducts, loading: searchLoading } = useSearchProducts();

    const categoryStore = useCategoryStore();

    const categoryTree = computed(() => categoryStore.categories);

    // State variables
    const title = ref(props.item?.title || "Sản phẩm mới");
    const tabs = ref(props.item?.product_cate_tabs || []);
    const activeTabIndex = ref(0);
    const loading = ref(true);
    const categoryLinks = ref<Record<number, string>>({});
    const getUrlImageDesktop = computed(() => {
      return props.item?.product_cate_tabs?.[activeTabIndex.value]?.image || "";
    });

    const getUrlImageMobile = computed(() => {
      return (
        props.item?.product_cate_tabs?.[activeTabIndex.value]?.mobile_image ||
        ""
      );
    });

    const getLink = computed(() => {
      return props.item?.product_cate_tabs?.[activeTabIndex.value]?.link || "";
    });

    // Get the category URL for "Xem thêm" button
    const getActiveCategoryUrl = () => {
      if (
        tabs.value.length === 0 ||
        activeTabIndex.value >= tabs.value.length
      ) {
        return "/";
      }

      const activeTab = tabs.value[activeTabIndex.value];

      // If the tab has a direct link, use that
      if (activeTab.link && activeTab.link.trim()) {
        return activeTab.link;
      }

      // Otherwise, use the category URL
      const activeCategoryId = activeTab.category_id;
      return categoryLinks.value[activeCategoryId] || "/";
    };

    // Handle tab switching
    const switchTab = async (index: number) => {
      if (activeTabIndex.value === index) return;

      loading.value = true;
      activeTabIndex.value = index;
      await fetchProductsByCategory();
    };

    // View all products in category
    const viewAll = () => {
      router.push(getActiveCategoryUrl());
    };

    // Fetch products by category ID
    const fetchProductsByCategory = async () => {
      if (
        tabs.value.length === 0 ||
        activeTabIndex.value >= tabs.value.length
      ) {
        loading.value = false;
        return;
      }

      try {
        products.value = []; // Clear products before fetching new ones
        loading.value = true;

        const activeCategoryId = tabs.value[activeTabIndex.value].category_id;

        const searchParams: {
          search?: string;
          filter: {
            [key: string]: any;
          };
          pageSize: number;
          currentPage: number;
          sort?: { [key: string]: string };
        } = {
          filter: {
            category_id: { eq: activeCategoryId },
            visibility: { in: ["4", "2", "3"] },
            status: { in: ["1", "0"] },
          },
          pageSize: props.item?.qty_product_display || 4,
          currentPage: 1,
          sort: { position: "ASC" },
        };

        const params = {
          ids: [String(activeCategoryId)],
          pageSize: props.item?.qty_product_display || 4,
        };
        const { data } = await fetchProducts(params);
        // const result = await searchProducts(searchParams);
        products.value = data || [];
      } catch (error) {
        products.value = [];
      } finally {
        loading.value = false;
      }
    };

    // Load category URLs for "Xem thêm" functionality
    const loadCategoryUrls = async () => {
      if (!tabs.value || tabs.value.length === 0) return;

      try {
        const categoryIds = tabs.value
          .map((tab) => tab.category_id)
          .filter(Boolean);
        const results = await Promise.all(
          categoryIds.map(async (id) => {
            const url_path = await getUrlPathByCategoryId(
              id,
              categoryTree.value
            );
            return {
              id,
              url: url_path ? `/${url_path}` : "/",
            };
          })
        );

        // Assign data to categoryLinks
        categoryLinks.value = Object.fromEntries(
          results.map(({ id, url }) => [id, url])
        );
      } catch (error) {}
    };

    onMounted(async () => {
      await loadCategoryUrls();
      await fetchProductsByCategory();
    });

    const OptionItemProductSale = {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 4,
      centeredSlides: false,
      loop: false,
      pagination: false,
      navigation: true,
      scrollbar: { draggable: true },
      freeMode: true,
      breakpoints: {
        640: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 4,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 4,
        },
        1024: {
          slidesPerView: 4.4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 5.4,
          slidesPerGroup: 5,
          spaceBetween: 20,
        },
      },
    };

    const OptionItemProductDefaul = {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 4,
      centeredSlides: false,
      loop: false,
      pagination: false,
      navigation: true,
      slidesPerColumn: 1,
      slidesPerColumnFill: "row",
      freeMode: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 4,
          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 4,
          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
      },
    };

    return {
      title,
      tabs,
      activeTabIndex,
      products,
      loading,
      switchTab,
      viewAll,
      searchLoading,
      categoryLinks,
      OptionItemProductDefaul,
      OptionItemProductSale,
      checkHttpLink,
      changeImage,
      getUrlImageDesktop,
      getUrlImageMobile,
      getLink,
    };
  },
});
